export default __webpack_public_path__ + "static/media/weekendlabs.4a10572a.jpeg";